"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ButtonList(props) {
  var data = props.data,
      isDesktop = props.isDesktop;


  if ((0, _lodash.isEmpty)(data)) {
    return false;
  }

  var _list = data;

  return _list.map(function (item, key) {
    var _key = key;
    var _anchor = !(0, _lodash.isEmpty)(item.anchor) ? item.anchor : "";
    var _action = !(0, _lodash.isEmpty)(item.action) ? item.action : "";
    var _actionValue = !(0, _lodash.isEmpty)(item.actionValue) ? item.actionValue : "";
    var _type = !(0, _lodash.isEmpty)(item.buttonType) ? item.buttonType.toUpperCase() : "";
    var _color = !(0, _lodash.isEmpty)(item.color) ? item.color : "";
    var _imgHeight = (0, _lodash.isInteger)(item.imageHeight) ? item.imageHeight : "";
    var _imgHeightMobile = (0, _lodash.isInteger)(item.imageHeightMobile) ? item.imageHeightMobile : "";
    var _imgWidth = (0, _lodash.isInteger)(item.imageWidth) ? item.imageWidth : "";
    var _imgWidthMobile = (0, _lodash.isInteger)(item.imageWidthMobile) ? item.imageWidthMobile : "";
    var _img = !(0, _lodash.isEmpty)(item.img) ? item.img.url : "";
    var _imgMobile = !(0, _lodash.isEmpty)(item.imgMobile) ? item.imgMobile.url : "";
    var _text = !(0, _lodash.isEmpty)(item.text) ? item.text : "";
    var _inverse = !(0, _lodash.isEmpty)(item.inverse) || item.inverse ? item.inverse : false;
    var _name = !(0, _lodash.isEmpty)(item.name) ? item.name : "";
    var _disabled = !(0, _lodash.isEmpty)(item.disabled) || item.disabled ? item.disabled : false;

    switch (_type) {
      case "NORMAL":
        return renderNormalButton({
          text: _text,
          color: _color,
          action: _action,
          actionValue: _actionValue,
          inverse: _inverse,
          key: _key,
          name: _name,
          anchor: _anchor,
          disabled: _disabled
        });

      case "IMAGE":
        return renderImageButton({
          action: _action,
          actionValue: _actionValue,
          img: _img,
          imgMobile: _imgMobile,
          imgHeight: _imgHeight,
          imgHeightMobile: _imgHeightMobile,
          imgWidth: _imgWidth,
          imgWidthMobile: _imgWidthMobile,
          key: _key,
          name: _name,
          anchor: _anchor,
          isDesktop: isDesktop
        });

      default:
        return;
    }
  });
};

var renderNormalButton = function renderNormalButton(_ref) {
  var text = _ref.text,
      color = _ref.color,
      action = _ref.action,
      actionValue = _ref.actionValue,
      inverse = _ref.inverse,
      variant = _ref.variant,
      key = _ref.key,
      anchor = _ref.anchor,
      disabled = _ref.disabled;


  var _key = key;
  var _text = text;
  var _color = color === 'primary' ? "rgb(246, 138, 51)" : "rgb(0, 62, 106)";
  var _action = action;
  var _actionValue = actionValue;
  var _anchor = anchor;
  var _disabled = disabled;

  return _react2.default.createElement(
    "span",
    {
      key: _key,
      style: {
        marginRight: "",
        marginBottom: "10px"
      }
    },
    _react2.default.createElement(
      "a",
      {
        style: {
          backgroundColor: _color,
          borderRadius: "4px",
          cursor: "pointer",
          color: "white",
          padding: "8px 16px"
        },
        key: _key,
        color: _color,
        href: _actionValue,
        onClick: function onClick(e) {
          e.preventDefault();
          if (_action === 'url' && _actionValue) {
            window.open(_actionValue);
          }
        },
        disabled: _disabled
      },
      _text
    )
  );
};

var renderImageButton = function renderImageButton(_ref2) {
  var action = _ref2.action,
      actionValue = _ref2.actionValue,
      img = _ref2.img,
      imgMobile = _ref2.imgMobile,
      imgHeight = _ref2.imgHeight,
      imgHeightMobile = _ref2.imgHeightMobile,
      imgWidth = _ref2.imgWidth,
      imgWidthMobile = _ref2.imgWidthMobile,
      key = _ref2.key,
      name = _ref2.name,
      anchor = _ref2.anchor,
      isDesktop = _ref2.isDesktop;

  var _key = key;
  var _action = action;
  var _actionValue = actionValue;
  var _img = img;
  var _imgMobile = imgMobile;
  var _imgHeight = imgHeight;
  var _imgHeightMobile = imgHeightMobile;
  var _imgWidth = imgWidth;
  var _imgWidthMobile = imgWidthMobile;
  var _isDesktop = isDesktop;
  var _name = name;

  if ((0, _lodash.isEmpty)(_action)) {
    return null;
  }

  return _react2.default.createElement(
    "a",
    {
      key: _key,
      "aria-label": _name,
      target: _action === 'url' ? "_blank" : undefined,
      href: _actionValue,
      style: {
        display: "block",
        cursor: "pointer"
      }
    },
    _react2.default.createElement("img", {
      src: _isDesktop ? _img : _imgMobile,
      alt: _name,
      style: {
        width: _isDesktop ? _imgWidth : _imgWidthMobile,
        height: _isDesktop ? _imgHeight : _imgHeightMobile
      }
    })
  );
};

exports.default = ButtonList;